"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledSystem = require("styled-system");

var _Icon = _interopRequireDefault(require("../Icon/Icon"));

var _elevation = _interopRequireDefault(require("../../utils/elevation"));

var buttonStyle = (0, _styledSystem.variant)({
  key: "buttons"
});

var justifyButtonText = function justifyButtonText(_ref) {
  var hideOverFlow = _ref.hideOverFlow,
      leadingIcon = _ref.leadingIcon,
      trailingIcon = _ref.trailingIcon;
  if (!hideOverFlow) return "space-around";
  if (leadingIcon && trailingIcon) return "center";
  if (leadingIcon) return "flex-end";
  if (trailingIcon) return "flex-start";
  return "space-around";
};

var StyledButton = _styledComponents["default"].button.withConfig({
  displayName: "Button__StyledButton",
  componentId: "m12atk-0"
})(["", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " display:flex;text-transform:uppercase;align-items:center;justify-content:", ";", " &:hover{cursor:pointer;}&:disabled{cursor:not-allowed;}"], _styledSystem.color, _styledSystem.width, _styledSystem.border, _styledSystem.borderRadius, _styledSystem.space, _styledSystem.height, buttonStyle, _styledSystem.fontSize, _styledSystem.fontFamily, _elevation["default"], _styledSystem.maxWidth, _styledSystem.minWidth, _styledSystem.alignSelf, justifyButtonText, function (_ref2) {
  var hideOverFlow = _ref2.hideOverFlow;
  return hideOverFlow ? "overflow: hidden; text-overflow: ellipsis; white-space: nowrap; position: relative;" : "";
});

StyledButton.propTypes = (0, _extends2["default"])({}, _styledSystem.fontFamily.propTypes, {}, _styledSystem.color.propTypes, {}, _styledSystem.width.propTypes, {}, _styledSystem.space.propTypes, {}, _styledSystem.border.propTypes, {}, _styledSystem.borderRadius.propTypes, {}, _styledSystem.height.propTypes, {}, _styledSystem.fontSize.propTypes, {
  disabled: _propTypes["default"].bool
});
StyledButton.defaultProps = {
  fontFamily: "sansSerif",
  bg: "primary",
  width: "auto",
  borderRadius: 3,
  m: 0,
  border: "none",
  variant: null,
  height: 2,
  buttonStyle: "primary",
  fontSize: 3,
  elevation: 2,
  px: 2,
  disabled: false
};
var ButtonIcon = (0, _styledComponents["default"])(_Icon["default"]).withConfig({
  displayName: "Button__ButtonIcon",
  componentId: "m12atk-1"
})(["", " ", ";"], function (_ref3) {
  var overFlow = _ref3.overFlow;
  return overFlow ? "position: absolute;" : "";
}, function (_ref4) {
  var type = _ref4.type,
      overFlow = _ref4.overFlow;
  return overFlow && type === "leading" ? "left: 10px" : "right: 10px";
});

var Button = function Button(_ref5) {
  var leadingIcon = _ref5.leadingIcon,
      trailingIcon = _ref5.trailingIcon,
      hideOverFlow = _ref5.hideOverFlow,
      children = _ref5.children,
      props = (0, _objectWithoutPropertiesLoose2["default"])(_ref5, ["leadingIcon", "trailingIcon", "hideOverFlow", "children"]);
  return _react["default"].createElement(StyledButton, (0, _extends2["default"])({}, props, {
    hideOverFlow: hideOverFlow,
    leadingIcon: leadingIcon,
    trailingIcon: trailingIcon
  }), leadingIcon && _react["default"].createElement(ButtonIcon, {
    type: "leading",
    name: leadingIcon,
    color: props.color,
    hideOverFlow: hideOverFlow
  }), children, trailingIcon && _react["default"].createElement(ButtonIcon, {
    type: "trailing",
    name: trailingIcon,
    color: props.color,
    hideOverFlow: hideOverFlow
  }));
};

Button.propTypes = (0, _extends2["default"])({}, StyledButton.propTypes, {
  leadingIcon: _propTypes["default"].string,
  trailingIcon: _propTypes["default"].string,
  children: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].element]).isRequired
});
Button.defaultProps = {
  leadingIcon: null,
  trailingIcon: null
};
var _default = Button;
exports["default"] = _default;